const activitySignupRouter = {
  route: null,
  name: null,
  title: '活动报名',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont el-icon-postcard',
  filePath: 'view/activity_signup/', // 文件路径
  order: 5,
  inNav: true,
  permission: ['活动报名'],
  children: [
    {
      title: '报名列表',
      type: 'view',
      name: 'activitySignupList',
      route: '/activity_signup/list',
      filePath: 'view/activity_signup/list.vue',
      inNav: true,
      icon: 'iconfont el-icon-notebook-2',
      permission: ['报名列表'],
    },
  ],
}

export default activitySignupRouter
